import { Box, Card, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import {
  userDashboardColors,
  type UserDashboardColorVariantType,
} from '../theme';

type ContentPropsType = {
  icon: ReactNode;
  label: string;
  value: string;
  subtext?: string;
  variant: UserDashboardColorVariantType;
  subtextAccent?: boolean;
  coloredValue?: boolean;
};

export const StatCardContent = ({
  icon,
  label,
  value,
  subtext,
  variant,
  subtextAccent = false,
  coloredValue = true,
}: ContentPropsType) => {
  const colors = userDashboardColors[variant];
  const valueColor = coloredValue
    ? colors.text
    : userDashboardColors.neutral.heading;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: colors.iconBg,
          color: colors.text,
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: 13,
            color: userDashboardColors.neutral.label,
            mb: 0.5,
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontSize: 22,
            fontWeight: 700,
            color: valueColor,
            lineHeight: 1.2,
          }}
        >
          {value}
        </Typography>
        {subtext ? (
          <Typography
            sx={{
              fontSize: 12,
              mt: 0.25,
              color: subtextAccent
                ? userDashboardColors.blue.accent
                : userDashboardColors.neutral.label,
              fontWeight: subtextAccent ? 700 : 400,
            }}
          >
            {subtext}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

type PropsType = ContentPropsType;

const StatCard = (props: PropsType) => (
  <Card
    sx={{
      p: 2.5,
      borderRadius: 3,
      border: `1px solid ${userDashboardColors.neutral.border}`,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
      height: '100%',
    }}
  >
    <StatCardContent {...props} />
  </Card>
);

export default StatCard;
